import * as React from 'react';
import Theme from './Theme';
import { ThemeStore } from './stores';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import { LoggingService } from '../../services/LoggingService';

export interface IThemeProps {
  environment?: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
}

export class IATheme extends React.Component<IThemeProps> {

  private themeStore: ThemeStore;

  constructor(props: IThemeProps) {
    super(props);

    this.themeStore = new ThemeStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.themeStore.environment = props.environment;
    this.themeStore.tenant = props.tenant;
    this.themeStore.token = props.token;
    LoggingService.init(this.props.environment);
  }

  public componentWillReceiveProps(props: IThemeProps) {
    if (props != this.props) {
      this.themeStore.environment = props.environment;
      this.themeStore.tenant = props.tenant;
      this.themeStore.token = props.token;
    }
  }

  public render(): JSX.Element {
    return (
      <Provider themeStore={this.themeStore}>
        <Theme />
      </Provider>
    );
  }
}